module.exports = __webpack_public_path__ + "img/espacio-logo.647dc0a9.png";